import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const shapeModURL = "api/v1/products-app/shape";
//obtaining the paginated data
export const getShape = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${shapeModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllShape = () => axiosInstance.get(`${shapeModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageShape = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${shapeModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createShape = (body) => axiosInstance.post(`${shapeModURL}/create`, body);
//updating function
export const updateShape = (id, body) => axiosInstance.patch(`${shapeModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${shapeModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataShapeName = (e, cancelToken) =>
  axiosInstance.get(`${shapeModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
